import dayjs from 'dayjs';

export interface EmailData {
  to: string;
  subject: string;
  body: string;
}
export interface batches {
  planExpiryDate: string;
  name: string;
  users: { email: string; name: string };
}

export const buildEmailBatch = (batches: batches[]): EmailData[] => {
  const emails: EmailData[] = [];

  batches.forEach((company) => {
    if (company.users && Array.isArray(company.users))
      company.users.forEach((user: { email: string; name: string }) => {
        if (user.email)
          emails.push({
            to: user.email,
            subject: `Your plan for ${company.name} is expiring soon!`,
            body: `
Hi ${user.name || ''},

Your company's plan **${company.name}** will expire on 
${dayjs(company.planExpiryDate).format('DD MMM YYYY')}.

Please renew to continue using the service.

Thank you,
Team Makanify
            `.trim(),
          });
      });
  });

  return emails;
};
